// @flow

import Q from 'q';

import $ from 'jquery';

import TraceKit from 'rgs-tracekit';

import Controller from './js/controller';

function init () {
	TraceKit.notifications = true;

	const domReady = Q.promise(function (resolve) {
		$(resolve);
	});

	domReady.then(() => {
		const controller = new Controller();

		require('debug-globals').extend({
			modalRedirectToOtherSiteController: controller,
		});
	})
	.done();
}

init();
